import React, { createContext, useContext } from 'react'
import { RenderOptions } from '../types'

const Context = createContext<RenderOptions>({})

/**
 *
 */
export const usePasswordManagerAppContext = () => useContext(Context)

/**
 *
 */
const PasswordManagerAppProvider = ({ children, options }: { children: React.ReactNode, options: RenderOptions }) => {
    return (
        <Context.Provider value={options}>
            {children}
        </Context.Provider>
    )
}

export default PasswordManagerAppProvider
